import { EDIT_MENU, RESET_MENU, SET_GROUPED_APPS } from 'app-redux/actionTypes'
import { putSidebarApps } from 'utils/apis'

const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
}

export const editMenu = (payload) => {
  return {
    type: EDIT_MENU,
    payload,
  }
}

export const resetMenu = (payload) => {
  return {
    type: RESET_MENU,
    payload,
  }
}

// Set daftar app yang di-grup (off). Menu tersusun ulang di reducer dari baseDashboard.
export const setGroupedApps = (payload) => {
  return {
    type: SET_GROUPED_APPS,
    payload,
  }
}

// Toggle satu app on/off secara optimistic: ubah redux dulu (menu langsung berpindah), simpan ke BE
// via PUT /finance/sidebarApps, rollback bila gagal. Mirip pola editOption. Return response BE.
export const toggleSidebarApp = (appName) => async (dispatch, getState) => {
  const name = (appName || '').toLowerCase()
  const current = (getState().menu.sidebarApps?.grouped_apps || []).map((app) =>
    (app || '').toLowerCase(),
  )
  const isGrouped = current.includes(name)
  const next = isGrouped ? current.filter((app) => app !== name) : [...current, name]

  dispatch(setGroupedApps(next))
  try {
    const res = await putSidebarApps(next)
    const saved = res?.data?.data?.grouped_apps
    if (Array.isArray(saved)) {
      dispatch(setGroupedApps(saved.map((app) => (app || '').toLowerCase())))
    }
    return res
  } catch (err) {
    dispatch(setGroupedApps(current)) // rollback; toast error otomatis via interceptor axios
    throw err
  }
}

export default actions
